import React from 'react';
import { IFFFChangeHandlerEvent } from '../../interfaces';

export function isReactChangeEvent(
  e: IFFFChangeHandlerEvent,
): e is React.ChangeEvent<HTMLInputElement | HTMLSelectElement> {
  return (
    (e as React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLElement>).target !==
    undefined
  );
}
